import React from "react";

// External
import styled from "@emotion/styled";

// Local
import { BoxColumn, BoxRow, colorScheme } from "../../styled/styled";
import { useScrollBounds } from "../../lib/useScrollBounds";

const Tooltip = ({ tooltip, dim }) => {
  const [tooltipRef, { containerHeight, containerWidth }] = useScrollBounds();

  const uniqueOrgCount = [
    ...new Set(tooltip.mutualCountries.map(ctry => ctry.orgCount))
  ];
  const mutualCtryTies = uniqueOrgCount.map(oc => {
    const tieCtries = tooltip.mutualCountries.filter(
      ctry => ctry.orgCount === oc
    );
    const nameTieCtries = tieCtries.map(ctry => ctry.country2);
    return { country: nameTieCtries, orgCount: oc };
  });

  const tooltipX = (x, containerWidth) => {
    if (x > dim.plotWidth / 2) {
      return x - containerWidth;
    } else return x;
  };

  const tooltipY = (y, containerHeight) => {
    if (y > dim.plotHeight / 2) {
      return y - containerHeight / 2;
    } else return y + containerHeight / 2;
  };

  const TooltipContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: absolute;
    z-index: 1;
    left: ${tooltipX(tooltip.x, containerWidth)}px;
    top: ${tooltipY(tooltip.y, containerHeight)}px;
    padding: 1em;
    width: 300px;
    color: ${colorScheme.neutralLightColor};
    background-color: ${colorScheme.neutralDarkColor};
    pointer-events: none;
    font-family: "Lato", serif;
    border-radius: 4px;
    opacity: 0.9;
  `;

  return (
    <TooltipContainer className="tooltip" ref={tooltipRef}>
      <BoxColumn>
        <BoxColumn style={{ marginBottom: "12px" }}>
          <BoxRow style={{ alignItems: "flex-end" }}>
            <div>
              <strong
                style={{
                  fontSize: "18px",
                  fontFamily: "'Circular Pro Book', sans-serif"
                }}
              >
                {tooltip.country}
              </strong>
            </div>
            <div>{tooltip.membershipCount} total memberships</div>
          </BoxRow>
        </BoxColumn>
        <BoxColumn
          style={{
            height: "12px",
            borderTop: `1px solid ${colorScheme.neutralLightColor}55`
          }}
        />
        <BoxColumn>
          <BoxRow style={{ opacity: "0.75" }}>
            <div>
              <small>Mostly joins with</small>
            </div>
            <div>
              <small>Memberships in common</small>
            </div>
          </BoxRow>
          {mutualCtryTies.map((muCtry, i) => (
            <BoxRow>
              <div
                style={{
                  width: "50%",
                  padding: "0.25em 0",
                  lineHeight: "1em"
                }}
              >
                <strong>
                  <small>{muCtry.country.join(", ")}</small>
                </strong>
              </div>
              <div>
                <small>
                  <strong>{muCtry.orgCount}</strong> (
                  {Math.floor(
                    (muCtry.orgCount / tooltip.membershipCount) * 100
                  )}
                  %)
                </small>
              </div>
            </BoxRow>
          ))}
        </BoxColumn>
      </BoxColumn>
    </TooltipContainer>
  );
};

export default Tooltip;
